import { ReactNode } from "react"

import { UserInfo } from "./UserInfo"

import { Box, Button, Img, Text } from "ui-kit/components-branded/index"

export function EndedForm(props: {
    header: ReactNode
    header2: string
    user: {
        name?: string
        photo?: string
        titles?: string[]
    }
    primaryButton: {
        text: string
        onClick: () => void
    }
    secondaryButton: {
        text: string
        onClick: () => void
    }
}) {
    return (
        <div className="after-call">
            <div className="is-flex is-justify-content-center after-call__wrapper">
                <Box className="after-call__card p-4 is-flex is-flex-direction-column">
                    <div className="is-flex-grow-1">
                        <div>
                            <Text isAccent className="after-call__thick-text">
                                {props.header}
                            </Text>
                        </div>
                        <div>
                            <Text className="after-call__thin-text">{props.header2}</Text>
                        </div>
                        <hr className="mb-3 after-call__hr" />
                        {props.user && (
                            <UserInfo
                                displayName={props.user.name}
                                faceUrl={props.user.photo}
                                titles={props.user.titles}
                            />
                        )}
                    </div>
                    <div className="is-flex is-flex-direction-column after-call__buttons">
                        <Button
                            color="primary"
                            className="after-call__primary-button"
                            onClick={props.primaryButton.onClick}
                        >
                            <Text isAccent>
                                <Img
                                    src="calendar.png"
                                    width={24}
                                    height={24}
                                    className="after-call__button-icon"
                                />{" "}
                                {props.primaryButton.text}
                            </Text>
                        </Button>
                        <Button
                            className="after-call__transparent-button"
                            onClick={props.secondaryButton.onClick}
                        >
                            {props.secondaryButton.text}
                        </Button>
                    </div>
                </Box>
            </div>
        </div>
    )
}
